import { render, staticRenderFns } from "./BrowseData.vue?vue&type=template&id=819220ee"
import script from "./BrowseData.vue?vue&type=script&lang=js"
export * from "./BrowseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports